<template>
  <div>
    <el-row>
      <el-col :span="5" v-if="isShow">
        <el-scrollbar :height="zoneListHeight">
          <div class="content-main" style="margin: 12px;">
            <p class="content-title">动态列表</p>
            <div class="content-input">
              <div style="margin-top: 12px;">
                <!--              <label style="line-height: 3">发表时间：</label>-->
                <DatePickerRange title="" @date="getExpireTime($event)" @check="getExpireCheck($event)" :isChecked="isExpireChecked" width="15em"/>
              </div>
              <div class="content-input-item">
                <label>动态序号：</label>
                <el-input v-model="zoneId" placeholder="请输入序号" style="width:10em;" clearable></el-input>
              </div>
              <div class="content-input-item">
                <ElButtons type="primary" icon="search" @click="getZonePage(true)" :loading="searchZoneLoading"> 查询 </ElButtons>
                <el-button type="success" @click="getZoneMsgPage(-1, -1)">全部评论</el-button>
              </div>
            </div>
            <div>
              <div style="margin-top: 16px;">
                <div v-for="(item, index) in pageDataZoneList" :key="index" class="list-item" :class="active == index?'active':''" @click="selectItem(index, item)">
                  <div class="list-item-title">
                    <p>序号：{{ item.id }}</p>
                    <p class="list-item-time">{{ item.createTime }}</p>
                  </div>
                  <p class="list-item-msg">{{ item.msg }}</p>
                </div>
              </div>
              <el-pagination small background layout="total, prev, pager, next" :total="totalZoneRow" :page-size="pageZoneSize" :current-page="currentZonePage" @current-change="handleCurrentChangeZone">
              </el-pagination>
            </div>
          </div>
        </el-scrollbar>
      </el-col>
      <el-col :span="isShow?19:24">
        <el-scrollbar :height="zoneListHeight">
          <div class="content-main" style="margin: 12px 12px 12px 0;position: relative" :style="{marginLeft: !isShow?'12px':''}">
            <div style="display: flex; align-items: center">
              <p class="content-title">官方动态互动</p>
              <p style="color: #aaaaaa;margin: 0 8px 2px 24px;">{{isShow?'显示':'隐藏'}}动态列表</p>
              <el-switch v-model="isShow" size="small"/>
            </div>
            <div class="editorInfo" @click="editEditorInfo()">
              <img :src="editorInfo.avatar" alt="" />
              <p>{{ editorInfo.nickName }}</p>
            </div>
            <div class="content-input">
              <div class="content-input-item">
                <label>展示状态：</label>
                <el-select v-model="state" placeholder="Select" style="width: 6.4em">
                  <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="content-input-item">
                <label>回复状态：</label>
                <el-select v-model="replyState" placeholder="Select" style="width: 6.4em">
                  <el-option v-for="item in replyStateArray" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="content-input-item">
                <DatePickerRange title="留言时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
              </div>
              <div class="content-input-item">
                <label>评论序号：</label>
                <el-input v-model="msgId" placeholder="请输入序号" :disabled="checked" style="width:8em;" clearable></el-input>
                <el-checkbox v-model="checked" style="margin-left: 12px;">不限序号</el-checkbox>
              </div>
              <div class="content-input-item">
                <ElButtons type="primary" icon="search" @click="getPage(true)" :loading="searchLoading"> 查询 </ElButtons>
                <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
              </div>
            </div>
          </div>
          <div class="content-main" style="margin: 12px 12px 12px 0;" :style="{marginLeft: !isShow?'12px':''}">
            <div class="content-button">
              <div>
                <el-button type="primary" @click="batchUpdate(1)" v-loading="bitchPassLoading">批量通过</el-button>
                <el-button type="danger"  @click="batchUpdate(2)" v-loading="bitchRejectLoading">批量不通过</el-button>
              </div>
              <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
            </div>
            <div class="content-table">
              <el-table
                  ref="multipleTableRef"
                  :data="pageDataList"
                  style="width: 100%"
                  v-loading="listLoading"
                  @cell-click="toggleSelection"
                  @selection-change="selsChange"
                  @header-click="selsAll"
                  border
              >
                <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
                <el-table-column property="createTime" label="发表时间" v-if="checkColList.indexOf('发表时间') > -1" width="100"/>
                <el-table-column property="msg" label="内容" v-if="checkColList.indexOf('内容') > -1"/>
                <el-table-column property="" label="类型" v-if="checkColList.indexOf('类型') > -1">
                  <template #default="scope">
                    <p>{{ scope.row.type == 2 ? '评论' : scope.row.type == 3 ? '回复' : '--' }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="官方回复" v-if="checkColList.indexOf('官方回复') > -1" class-name="cursor" width="100">
                  <template #default="scope">
                    <p v-if="scope.row.officialReplyMsg">{{scope.row.officialReplyMsg}}</p>
                    <el-button type="text" v-else>回复</el-button>
                  </template>
                </el-table-column>
                <el-table-column property="id" label="评论序号" v-if="checkColList.indexOf('评论序号') > -1" width="100"/>
                <el-table-column label="发表人" v-if="checkColList.indexOf('发表人') > -1" width="190">
                  <template #default="scope">
                    <UserInfoList :row="scope.row.user" showList="name,uid,phone"/>
                  </template>
                </el-table-column>
                <el-table-column label="发表人头像" v-if="checkColList.indexOf('发表人头像') > -1" width="110">
                  <template #default="scope">
                    <div v-if="scope.row.user">
                      <el-image
                          style="width: 80px; height: 80px"
                          :src="scope.row.user.headImg.smallHeadImg"
                          @click="showImg(scope.row.user)"
                          class="cursor"
                      >
                        <template #error><div class="el-img-error">暂无图片</div></template></el-image>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="发表人日志" v-if="checkColList.indexOf('发表人日志') > -1" class-name="cursor" width="180">
                  <template #default="scope">
                    <UserLog :user-log-list="scope.row.userLog" />
                  </template>
                </el-table-column>
                <el-table-column prop="" label="评论作者" width="190" v-if="checkColList.indexOf('评论作者') > -1">
                  <template #default="scope">
                    <div v-if="scope.row.toResumeInfo"><UserInfoList :row="scope.row.toResumeInfo" showList="name,uid,phone"/></div>
                  </template>
                </el-table-column>
<!--                <el-table-column prop="" label="动态作者" width="190" v-if="checkColList.indexOf('动态作者') > -1">-->
<!--                  <template #default="scope">-->
<!--                    <div v-if="scope.row.toUserId == 0">-->
<!--                      {{ scope.row.officialInfo.nickName }}-->
<!--                    </div>-->
<!--                    <div v-else>-->
<!--                      <UserInfoList :row="scope.row.toUser" showList="name,uid,phone"/>-->
<!--                    </div>-->
<!--                  </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column label="作者头像" v-if="checkColList.indexOf('作者头像') > -1" width="110">-->
<!--                  <template #default="scope">-->
<!--                    <el-image-->
<!--                        v-if="scope.row.toUserId == 0"-->
<!--                        style="width: 80px; height: 80px"-->
<!--                        :src="scope.row.officialInfo.avatar"-->
<!--                        class="cursor"-->
<!--                    >-->
<!--                      <template #error><div class="el-img-error">暂无图片</div></template></el-image>-->
<!--                    <div v-if="scope.row.toUser">-->
<!--                      <el-image-->
<!--                          v-if="scope.row.toUserId != 0"-->
<!--                          style="width: 80px; height: 80px"-->
<!--                          :src="scope.row.toUser.headImg.smallHeadImg"-->
<!--                          @click="showImg(scope.row.toUser)"-->
<!--                          class="cursor"-->
<!--                      >-->
<!--                        <template #error><div class="el-img-error">暂无图片</div></template></el-image>-->
<!--                    </div>-->

<!--                  </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column label="作者日志" v-if="checkColList.indexOf('作者日志') > -1" class-name="cursor" width="180">-->
<!--                  <template #default="scope">-->
<!--                    <UserLog :user-log-list="scope.row.toUserLog" />-->
<!--                  </template>-->
<!--                </el-table-column>-->
                <el-table-column label="状态" v-if="checkColList.indexOf('状态') > -1">
                  <template #default="scope">
                    <p>{{ scope.row.state == 0 ? '待审核' : scope.row.state == 1 ? '审核通过' : scope.row.state == 2 ? '审核不通过' : '--' }}</p>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
              </el-pagination>
            </div>
          </div>
        </el-scrollbar>

      </el-col>
    </el-row>

  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import {
  getOfficialInteractPageList, updateZoneInteractState, getOfficialMsgPageList, getOfficialInfo
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import UserLog from "@/components/UserLog/UserLog";
import officialInteractReplyDialog from "@/views/dynamic/components/officialInteractReplyDialog";
import EditorInfoDialog from "@/views/dynamic/components/EditorInfoDialog";

export default {
  name: "DynamicOfficialInteract",
  components: { DatePickerRange, SearchComponents, BtnGroup, UserLog },
  data() {
    return {

      stateArray: [
        {label: '不限', value: -1},
        {label: '待审核', value: 0},
        {label: '已通过', value: 1},
        {label: '未通过', value: 2}
      ],
      state: 0,

      replyStateArray: [
        {label: '不限', value: -1},
        {label: '已回复', value: 1},
        {label: '未回复', value: 0},
      ],
      replyState: 0,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //发表时间
      startExpire: '',
      endExpire: '',
      isExpireChecked: true,

      msgId: '',
      zoneId: '',
      checked: true,

      active: -1,

      isShow: true,

      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['发表时间', '内容', '类型', '官方回复', '评论序号', '发表人', '发表人头像','发表人日志', '评论作者', '状态'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      pageDataZoneList: [],
      currentZonePage: 1,
      totalZoneRow: 0,
      pageZoneSize: 20,

      listLoading: false,
      searchLoading: false,
      listZoneLoading: false,
      searchZoneLoading: false,
      bitchPassLoading: false,
      bitchRejectLoading: false,
      bitchHideLoading: false,
      bitchForbidLoading: false,


      idArray: [],

      zoneListHeight: '640px',

      editorInfo: {},

    }
  },
  methods: {

    selectItem(idx, item) {
      this.active = idx
      this.zoneId = item.id
      this.getPage()
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //分页
    handleCurrentChangeZone(val) {
      this.zoneId = '';
      this.currentZonePage = val;
      this.getZonePage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getExpireTime(val) {
      this.startExpire = val[0];
      this.endExpire = val[1];
      // console.log(val)
    },

    getExpireCheck(val) {
      this.isExpireChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.checked = true;
      this.state = 0;
      this.replyState = 0;
      this.msgId = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getZoneMsgPage(id, idx) {
      if (id == -1) {
        this.zoneId = '';
        this.msgId = '';
      } else {
        this.zoneId = id;
      }
      this.active = idx;
      this.refreshParam();
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['replyState'] = this.replyState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['zoneId'] = this.zoneId ? this.zoneId : 0;
      if (this.checked) {
        param['id'] = 0;
      } else {
        param['id'] = this.msgId ? this.msgId : 0;
      }
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getOfficialInteractPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },


    getZonePage(reset) {
      if(isNaN(this.currentZonePage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentZonePage = 1;
        }
        this.searchZoneLoading = true;
        this.listZoneLoading = true;
        this.sendZonePageReq(this.getZonePageParam(this.currentZonePage));
      }
    },

    //页面参数
    getZonePageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['id'] = this.zoneId ? this.zoneId : 0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendZonePageReq(param) {
      getFormData(getOfficialMsgPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataZoneList = result['records'];
          this.totalZoneRow = result['total'];
          this.pageZoneSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchZoneLoading = false;
        this.listZoneLoading = false;
      })
          .catch((response) => {
            this.searchZoneLoading = false;
            this.listZoneLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      if(column.label == '发表人日志') {
        Dialog.open({
          title: '发表人日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLog'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      if(column.label == '作者日志' && row.toUserId != 0) {
        Dialog.open({
          title: '作者日志',
          component: UserLogDialog,
          data: {
            id: row.toUserId
          },
          close: () => {
            row['toUserLog'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      if(column.label == '官方回复') {
        Dialog.open({
          title: '官方回复',
          component: officialInteractReplyDialog,
          data: {
            row: row,
            width: '600px'
          },
          confirm: (result) => {
            row.officialReplyMsg = result.msg
            for(let i=0;i<this.pageDataList.length;i++) {
              if(this.pageDataList[i].id == row.id) {
                this.pageDataList.splice(i, 1);
              }
            }
          }
        })
      }

    },

    batchUpdate(state) {
      if(this.idArray.length > 0) {
        this.$confirm('确认批量'+ (state == 1?'【通过】':'【不通过】') +'选中的评论？').then(()=>{
          if(state == 1) {
            this.bitchPassLoading = true;
          }else {
            this.bitchRejectLoading = true;
          }
          let _this = this;
          let param = {};
          param['idArr'] = this.idArray
          param['state'] = state
          postFormData(updateZoneInteractState, param).then((data) => {
            let {code, msg} = data;
            if(code == 200) {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
              for(let j=0;j<_this.idArray.length;j++){
                for(let i=0;i<_this.pageDataList.length;i++) {
                  if(_this.pageDataList[i]['id'] == _this.idArray[j]) {
                    _this.pageDataList.splice(i,1);
                    i--;
                  }
                }
              }
              if(_this.pageDataList.length == 0){
                _this.getPage();
              }
            }else {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              });
            }
            _this.bitchPassLoading = false;
            _this.bitchRejectLoading = false;
          })
              .catch(()=>{
                _this.bitchPassLoading = false;
                _this.bitchRejectLoading = false;
              })
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
      }
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList
      })
    },

    getEditorInfo() {
      getFormData(getOfficialInfo).then((data) => {
        if(data.code == 200) {
          this.editorInfo = data.data;
        }
      })
    },

    editEditorInfo() {
      let _title = '编辑官方信息';
      Dialog.open({
        title: _title,
        component: EditorInfoDialog,
        data: {
          editorForm: this.editorInfo,
        },
        confirm: (result) => {
          this.getEditorInfo()
        }
      })
    }

  },
  created() {
    this.zoneListHeight = (window.innerHeight - 48)  + 'px'
  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getZoneMsgPage(-1, -1);
    this.getZonePage()
    this.getEditorInfo()
  }
}
</script>

<style scoped>
.list-item {
  padding: 16px;
  border: 1px solid #ebeef5;
  margin: 12px 0;
  border-radius: 4px;
  cursor: pointer;
}

.list-item:hover {
  box-shadow: rgba(0,0,0,0.15) 0 0 8px;
}
.list-item-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: bold;
}
.list-item-time {
  font-size: 12px;
  color: #aaaaaa;
  font-weight: normal;
}

.list-item-msg {
  /*font-size: 13px;*/
  color: #666666;
  word-break: break-all;
  text-align: justify;
}
.list-item-msg span {
  color: #3a8ee6;
  margin-left: 8px;
}

.ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.active {
  background-color: #f5f7fa;
  border: 1px solid #cfe7ff;
}
.editorInfo {
  display: flex;
  align-items: center;
  background-color: #f6f6f6;
  padding: 0 12px;
  height: 34px;
  border-radius: 17px;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  font-size: 12px;
}
.editorInfo img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  border-radius: 50%;
}
</style>
